<template>
    <div class="animated fadeIn">
        <LoadingWidget
            v-if="initStatus != 1"
            :status="initStatus"
            @init="init"
        />
        <b-card v-else>
            <h5><i class="fa fa-tv mr-2" />TV Commercial Item</h5>
            <hr />
            <b-row>
                <b-col md="6" class="text-left">
                    <h5 class="font-weight-bold">{{ groupName }}</h5>
                </b-col>
                <b-col md="6" class="text-right">
                    <b-button variant="success" @click="openModalAddTVCItem">
                        <i class="fa fa-plus mr-2" />Item Baru
                    </b-button>
                </b-col>
            </b-row>
            <b-table
                bordered
                hover
                show-empty
                no-local-sorting
                :busy="isBusy"
                :items="items"
                :fields="fields"
                @sort-changed="onSortChanged"
                responsive
                class="my-3"
            >
                <template v-slot:empty>
                    Tidak ada data item.
                </template>
                <template v-slot:cell(name)="row">
                    <div>
                        <div class="product-name">{{ row.item.name }}</div>
                        <div class="product-details">
                            {{ row.item.kind }} • {{ row.item.brand }}
                        </div>
                    </div>
                </template>
                <template v-slot:cell(price)="row">
                    <div>Rp. {{ $helper.formatThousand(row.item.price) }}</div>
                </template>
                <template v-slot:cell(stock)="row">
                    <div>
                        {{ row.item.stock }}
                    </div>
                </template>
                <template v-slot:cell(action)="row">
                    <b-button
                        size="sm"
                        class="ml-2"
                        variant="danger"
                        v-b-tooltip.hover.top
                        title="Hapus"
                        @click="openModalDeleteTVCItem(row.item)"
                    >
                        <i class="fa fa-fw fa-trash" />
                    </b-button>
                </template>
            </b-table>
            <PageSizer
                :totalRows="totalRows"
                :page="currentPage"
                :options="options"
                @limit-change="onLimitChange"
                @page-change="onPageChange"
            />
        </b-card>

        <b-modal id="m-add-tvc-item" title="Add TVC Item" centered hide-footer>
            <div class="my-2">
                <b-form-group label="Jenis Barang" id="kind-group">
                    <multiselect
                        v-model="input.kind"
                        id="kind-select"
                        label="name"
                        track-by="id"
                        :options="optKinds"
                        placeholder="-- Pilih Salah Satu --"
                        :allow-empty="false"
                        :internal-search="true"
                        @input="getBrands"
                    />
                </b-form-group>
            </div>
            <div class="my-2">
                <b-form-group label="Merk Barang" id="brand-group">
                    <multiselect
                        v-model="input.brand"
                        label="name"
                        id="brand-select"
                        track-by="id"
                        :options="optBrands"
                        placeholder="-- Pilih Salah Satu --"
                        :disabled="isFetching || !input.kind"
                        :allow-empty="false"
                        :internal-search="true"
                        @input="getTypes"
                    />
                </b-form-group>
            </div>
            <div class="my-2">
                <b-form-group label="Tipe Barang" id="type-group">
                    <multiselect
                        v-model="input.type"
                        label="name"
                        id="type-select"
                        track-by="id"
                        :options="optTypes"
                        placeholder="-- Pilih Salah Satu --"
                        :disabled="isFetching || !input.brand"
                        :allow-empty="false"
                        :internal-search="true"
                    />
                </b-form-group>
            </div>
            <p class="tvc-item-note">
                *Stock akan diatur ke 0 saat penambahan dan akan diperbarui
                secara otomatis melalui sistem dalam waktu ±1 menit.
            </p>
            <b-row>
                <b-col md="12" class="text-right">
                    <b-button variant="success" @click="addTVCItem">
                        {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                    </b-button>
                </b-col>
            </b-row>
        </b-modal>

        <b-modal
            id="m-delete-tvc-item"
            title="Delete TVC Item"
            centered
            hide-footer
        >
            <p>Apakah anda yakin ingin menghapus item ini?</p>
            <b-row>
                <b-col md="12" class="text-right">
                    <b-button
                        variant="outline-primary"
                        class="mr-2"
                        :disabled="isSubmitting"
                        @click="$bvModal.hide('m-delete-tvc-item')"
                    >
                        Batal
                    </b-button>
                    <b-button
                        variant="danger"
                        :disabled="isSubmitting"
                        @click="deleteTVCItem"
                    >
                        {{ isSubmitting ? "Menghapus..." : "Hapus" }}
                    </b-button>
                </b-col>
            </b-row>
        </b-modal>
    </div>
</template>

<script>
export default {
    data() {
        return {
            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            options: [
                { value: 10, text: "10" },
                { value: 20, text: "20" },
                { value: 30, text: "30" },
                { value: 40, text: "40" },
                { value: 50, text: "50" }
            ],
            fields: [
                { key: "name", label: "Item", sortable: true },
                { key: "price", label: "Harga", sortable: true },
                { key: "stock", label: "Stok", sortable: true },
                { key: "action", label: "Aksi" }
            ],
            items: [],
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,
            optTVCGroups: [{ id: 1, name: "Handphone" }],
            optItems: [],
            optKinds: [],
            optBrands: [],
            optTypes: [],
            searchItem: "",
            input: {
                kind: null,
                brand: null,
                type: null
            },
            deleteId: null,
            isFetching: false,
            groupName: ""
        };
    },

    methods: {
        init() {
            this.initStatus = 0;

            let getTVCItems = this.getTVCItems();
            let getKinds = this.getKinds();

            Promise.all([getTVCItems, getKinds])
                .then(() => {
                    this.initStatus = 1;
                })
                .catch(_ => {
                    this.initStatus = -1;
                });
        },

        getTVCItems(page = 1) {
            this.isBusy = true;
            this.items = [];

            const id = this.$route.params.id;

            if (isNaN(page)) {
                this.currentPage = 1;
            } else {
                this.currentPage = page;
            }

            let param = this.$helper.getBasePagedQuery(
                this.currentPage,
                this.perPage
            );

            if (!this.$helper.isBlank(this.sortBy)) {
                param += "&sortBy=" + this.sortBy;
                param += "&sortDesc=" + this.sortDesc;
            }

            if (id) {
                param += "&group_id=" + id;
            }

            return this.$axios
                .get("sm-tvc/items" + param)
                .then(res => {
                    const data = res.data.data;
                    this.items = data.items;
                    this.totalRows = res.data.data.total;

                    if (data.items.length > 0) {
                        this.groupName = data.items[0].group_name;
                    }
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },

        getKinds() {
            this.input.brand = null;
            this.input.type = null;
            this.isFetching = true;

            this.$axios
                .get("master/kinds")
                .then(res => {
                    this.optKinds = res.data.data;
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                })
                .finally(() => {
                    this.isFetching = false;
                });
        },

        getBrands() {
            this.input.brand = null;
            this.input.type = null;
            this.isFetching = true;

            this.$axios
                .get(`master/brands/${this.input.kind.id}`)
                .then(res => {
                    this.optBrands = res.data.data;
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                })
                .finally(() => {
                    this.isFetching = false;
                });
        },

        getTypes() {
            this.input.type = null;
            this.isFetching = true;

            this.$axios
                .get(`master/types/${this.input.brand.id}`)
                .then(res => {
                    this.optTypes = res.data.data;
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                })
                .finally(() => {
                    this.isFetching = false;
                });
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy;
            this.sortDesc = ctx.sortDesc;
            this.getTVCItems();
        },

        onPageChange(newPage) {
            this.currentPage = newPage;
            this.getTVCItems(this.currentPage);
        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage;
            this.getTVCItems(this.currentPage);
        },

        addTVCItem() {
            this.isSubmitting = true;

            const payload = {
                tvc_groups_id: Number(this.$route.params.id),
                item_type_id: this.input.type.id
            };

            this.$axios
                .post("sm-tvc/items", payload)
                .then(_ => {
                    this.$helper.toastSuccess(
                        this,
                        "Item berhasil ditambahkan!"
                    );
                    this.getTVCItems();
                    this.isSubmitting = false;
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                })
                .finally(() => {
                    this.isSubmitting = false;
                    this.input.kind = null;
                    this.input.brand = null;
                    this.input.type = null;
                    this.$bvModal.hide("m-add-tvc-item");
                });
        },
        deleteTVCItem() {
            this.isSubmitting = true;
            this.$axios
                .delete("sm-tvc/items/" + this.deleteId)
                .then(_ => {
                    this.$helper.toastSuccess(this, "Item berhasil dihapus!");
                    this.isSubmitting = false;
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => {
                    this.isSubmitting = false;
                    this.$bvModal.hide("m-delete-tvc-item");
                    this.getTVCItems();
                });
        },

        openModalAddTVCItem() {
            this.$bvModal.show("m-add-tvc-item");
        },

        openModalDeleteTVCItem(item) {
            this.$bvModal.show("m-delete-tvc-item");
            this.deleteId = item.id;
        }
    },
    created() {
        this.init();
    }
};
</script>
<style scoped>
.product-name {
    font-size: 16px;
    font-weight: 500;
    color: #2d3748;
}

.product-details {
    font-size: 12px;
    color: #6b7280;
}

.tvc-item-note {
    font-size: 10px;
    color: #6b7280;
}
</style>
